import { useStore } from './store';
import { Lobby } from './components/Lobby';
import { GameBoard } from './components/GameBoard';

export default function App() {
  const connected = useStore((s) => s.connected);
  const remote = useStore((s) => s.remote);

  // 遊戲中：不套 fit-stage 縮放，讓 Phaser 全權接管視窗
  if (connected && remote) return <GameBoard />;

  // 大廳畫面：使用全螢幕響應式排版
  return <Lobby />;
}
